import { useState } from "react";

// Set to true to mock form submission instead of sending to Formcarry
const MOCK_SUBMISSION = false;

export const useFormSubmit = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success', 'error', null

  const submitForm = async (formType, name, email, message) => {
    setIsSubmitting(true);
    setSubmitStatus(null);

    // Format the message with form type at the top and two newlines between fields
    const formattedMessage =
      `form type: ${formType}` +
      `\n\nName: ${name}` +
      `\n\nEmail: ${email}` +
      `\n\n${message}`;

    try {
      if (MOCK_SUBMISSION) {
        // Mock submission - simulate network delay
        await new Promise((resolve) => setTimeout(resolve, 1000));
        console.log("Mock form submission:", {
          formType,
          name,
          email,
          message: formattedMessage,
        });
        setSubmitStatus("success");
        return { success: true };
      }

      const response = await fetch("https://formcarry.com/s/prG9jVUYb6N", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, email, message: formattedMessage }),
      });

      if (response.ok) {
        setSubmitStatus("success");
        return { success: true };
      } else {
        setSubmitStatus("error");
        return { success: false, error: "Failed to submit form" };
      }
    } catch (error) {
      setSubmitStatus("error");
      return { success: false, error: error.message };
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetStatus = () => {
    setSubmitStatus(null);
  };

  return {
    submitForm,
    isSubmitting,
    submitStatus,
    resetStatus,
  };
};
